export const goNext = (swiperRef: { current: any }) => {
  const ref = swiperRef.current;
  if (ref) {
    if (ref.swiper) {
      ref.swiper.slideNext();
    }
  }
};

export const goPrev = (swiperRef: { current: any }) => {
  const ref = swiperRef.current;
  if (ref) {
    if (ref.swiper) {
      ref.swiper.slidePrev();
    }
  }
};

export const goToSlide = (swiperRef: { current: any }, n: number) => {
  const ref = swiperRef.current;
  if (ref) {
    if (ref.swiper) {
      ref.swiper.slideTo(n);
    }
  }
};

export const swiperActiveIndex = (swiperRef: { current: any }) => {
  const ref = swiperRef.current;
  if (ref && ref.swiper) {
    return ref.swiper.activeIndex as number;
  }
  return 0
};
